import $axios from "../../api";

const state = () => ({
  data: [],
  modalData: [],
  isLoading: false,
  isSuccess: false,
});

const mutations = {
  SET_DATA(state, payload) {
    state.data = payload;
  },
  SET_MODAL_DATA(state, payload) {
    state.modalData = payload;
  },
  SET_RESYNC_STATE(state, { index, item }) {
    state.modalData.splice(index, 1, item);
  },
  SET_IS_RESYNCING(state, payload) {
    state.isResyncing = payload;
  },
  SET_RESYNC_BUTTON_TEXT(state, payload) {
    state.resyncButtonText = payload;
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
};

const actions = {
  getDashboardITData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`dashboardsync/data/list`)
        .then((response) => {
          commit("SET_DATA", response.data.data);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  resyncExternalData({ commit, dispatch, state }, { item, index }) {
    commit('SET_RESYNC_STATE', { index, item: { ...item, isResyncing: true } });
    return new Promise((resolve, reject) => {
      const endpoint = `dashboardsync/resync/${item.endpoint_resync}`;

      $axios.post(endpoint, { sync_master_id: [item.id] })
        .then(async (response) => {
          await dispatch('getDashboardITData');
          dispatch('Main/globalCustomSweetAlert', {
            message: `${item.key_value} Resync successful`,
            position: 'top-end',
            timer: 2000,
          }, { root: true });
          resolve(response);
        })
        .catch((error) => {
          dispatch('Main/globalSweetAlert', {
            message: `Error resyncing data: ${error.message}`,
            icon: 'error',
          }, { root: true });
          reject(error);
        })
        .finally(() => {
          commit('SET_RESYNC_STATE', { index, item: { ...item, isResyncing: false } });

          const tableKey = item.table_name;
          let updatedList;

          if (item.endpoint_resync === 'web') {
            updatedList = state.data.sync_table_toko_to_unionweb[tableKey]?.list || state.modalData;
          } else {
            updatedList = state.data.sync_table_unionweb_to_union[tableKey]?.list || state.modalData;
          }

          commit('SET_MODAL_DATA', updatedList);
        });
    });
  }

};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
